export default {
  brandColor1: '#363636',
  complimentaryColor1: '#fff',
  brandColor2: '#F8AD00',
  complimentaryColor2: '#fff',
};
